import { BuiltinDoorId } from "building-types/doors/BuiltinDoorId";
import type { OpeningPlacementOptions } from "building-types/openings/openingFuncOptions";
import { OpeningPlacementFilter, RoomFilter } from "building-types/openings/openingTypesEnum";
import { RoomType } from "building-types/rooms/roomTypesEnum";

/**
 *
 */
export const DefaultRoomTypeOpeningPlacements: OpeningPlacementOptions[] = [
  /** Open Connected Rooms */
  {
    roomStartFilter: RoomFilter.OPEN_CONNECTED,
    roomEndFilter: RoomFilter.OPEN_CONNECTED,
    options: { funcType: "DOOR", doorType: BuiltinDoorId.OPEN_FULL },
  },
  /** Default Windows */
  {
    roomStartFilter: RoomFilter.ALL,
    roomEndFilter: RoomFilter.NOT_ENCLOSED,
    options: { funcType: "WINDOW" },
  },
  /** General Circulation */
  {
    roomStartTypes: [
      RoomType.MASTER_BED,
      RoomType.BEDROOM,
      RoomType.BATHFULL,
      RoomType.BATHFULL_1_DOOR,
      RoomType.BATH_HALL,
      RoomType.WORKSHOP,
      RoomType.GARAGE,
      RoomType.GENERAL,
    ],
    roomEndTypes: [RoomType.HALL],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.INT_24XX },
  },
  {
    roomStartTypes: [
      RoomType.MASTER_BED,
      RoomType.BEDROOM,
      RoomType.BATHFULL,
      RoomType.BATHFULL_1_DOOR,
      RoomType.BATH_HALL,
      RoomType.WORKSHOP,
      RoomType.GARAGE,
      RoomType.GENERAL,
    ],
    roomEndTypes: [RoomType.HALL_CASED_OPENING],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.INT_26XX, center: true },
  },
  {
    roomStartTypes: [RoomType.FOYER],
    roomEndTypes: [RoomType.HALL, RoomType.FLEX],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.OPEN_40XX, center: true },
  },
  {
    roomStartTypes: [RoomType.HALL_CASED_OPENING],
    roomEndTypes: [RoomType.HALL_CASED_OPENING],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.OPEN_FULL },
  },
  {
    roomStartTypes: [RoomType.HALL_CASED_OPENING],
    roomEndTypes: [RoomType.REACH_CLOSET, RoomType.JUMP],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.CL_BYPASS },
  },
  {
    roomStartTypes: [RoomType.HALL_CASED_OPENING],
    roomEndTypes: [RoomType.FOYER, RoomType.ENTRY],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.OPEN_40XX, center: true },
  },
  {
    roomStartTypes: [RoomType.HALL_CASED_OPENING],
    roomEndTypes: [RoomType.CLOSET],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.INT_24XX, center: true },
  },
  {
    roomStartTypes: [RoomType.KITCHEN_HALL],
    roomEndTypes: [
      RoomType.KITCHEN,
      RoomType.KITCHEN_HALL,
      RoomType.KITCHEN_CABINETS,
      RoomType.LIVING,
      RoomType.LIVING_HALL,
      RoomType.DINING,
      RoomType.HALL,
    ],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.OPEN_FULL },
  },

  /** Stairs */
  {
    roomStartTypes: [RoomType.STAIRS],
    roomEndTypes: [RoomType.HALL],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.OPEN_FULL },
  },
  {
    roomStartTypes: [RoomType.STAIRS_EDITOR],
    roomEndTypes: [RoomType.HALL],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.OPEN_FULL },
  },
  {
    roomStartTypes: [RoomType.STAIRS_EDITOR],
    roomEndTypes: [RoomType.STAIRS_EDITOR],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.OPEN_FULL },
  },
  {
    roomStartTypes: [RoomType.STAIRS_EDITOR],
    roomEndTypes: [RoomType.COAT_CLOSET],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.OPEN_FULL },
  },

  /** Utility */
  {
    roomStartTypes: [RoomType.GARAGE],
    roomEndTypes: ["" as RoomType],
    options: { funcType: "GARAGE_DOOR" },
  },
  {
    roomStartTypes: [RoomType.GARAGE],
    roomEndTypes: [RoomType.GARAGE],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.OPEN_FULL },
  },
  {
    roomStartTypes: [RoomType.WORKSHOP, RoomType.MUDROOM, RoomType.MECH],
    roomEndTypes: [RoomType.GARAGE],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.INT_24XX },
  },
  {
    roomStartTypes: [RoomType.UTIL_HALL, RoomType.HALL],
    roomEndTypes: [RoomType.GARAGE, RoomType.WORKSHOP],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.INT_30XX, center: true },
  },
  {
    roomStartTypes: [RoomType.LAUNDRY],
    roomEndTypes: [RoomType.ENTRY, RoomType.MUDROOM],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.INT_24XX },
  },
  {
    roomStartTypes: [RoomType.LAUNDRY],
    roomEndTypes: [RoomType.HALL, RoomType.MUDROOM],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.INT_24XX },
  },
  {
    roomStartTypes: [RoomType.LAUNDRY],
    roomEndTypes: [RoomType.GARAGE],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.INT_24XX },
  },
  {
    roomStartTypes: [RoomType.MUDROOM],
    roomEndTypes: [RoomType.JUMP, RoomType.HALL],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.OPEN_30XX, center: true },
  },
  {
    roomStartTypes: [RoomType.LAUNDRY],
    roomEndTypes: [RoomType.JUMP],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.INT_28XX },
  },
  {
    roomStartTypes: [RoomType.JUMP],
    roomEndTypes: [RoomType.HALL, RoomType.UTIL_HALL],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.OPEN_30XX, center: true },
  },
  {
    roomStartTypes: [RoomType.JUMP],
    roomEndTypes: [RoomType.GARAGE],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.INT_30XX, center: true },
  },
  /** Bath */
  {
    roomStartTypes: [RoomType.BATHFULL, RoomType.BATHFULL_1_DOOR],
    roomEndTypes: [RoomType.BED_PASS, RoomType.HALL],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.INT_24XX },
  },
  /** Bedrooms */
  {
    roomStartTypes: [RoomType.BEDROOM],
    roomEndTypes: [RoomType.JJ_BATH],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.INT_24XX },
  },
  {
    roomStartTypes: [RoomType.BED_BATH],
    roomEndTypes: [RoomType.BEDROOM],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.INT_24XX },
  },
  {
    roomStartTypes: [RoomType.MASTER_HALL],
    roomEndTypes: [RoomType.MASTER_BED],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.OPEN_FULL },
  },
  {
    roomStartTypes: [RoomType.CLOSET],
    roomEndTypes: [RoomType.BEDROOM],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.INT_24XX },
  },
  {
    roomStartTypes: [RoomType.BEDROOM, RoomType.GENERAL, RoomType.OFFICE, RoomType.GUEST_SUITE],
    roomEndTypes: [RoomType.BED_PASS],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.OPEN_FULL },
    filter: OpeningPlacementFilter.DIFFERENT_BLOCKS,
  },
  {
    roomStartTypes: [RoomType.BED_CLOSET],
    roomEndTypes: [RoomType.BEDROOM, RoomType.BED_PASS],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.INT_24XX },
  },

  /** Kitchen */
  {
    roomStartTypes: [RoomType.PANTRY],
    roomEndTypes: [RoomType.HALL, RoomType.KITCHEN_HALL, RoomType.LIVING_HALL],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.INT_24XX },
  },

  /** Exterior Connections */
  {
    roomStartTypes: [RoomType.MUDROOM, RoomType.GARAGE],
    roomEndTypes: [RoomType.WALK, RoomType.BREEZEWAY],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.EXT_SGL },
  },
  {
    roomStartTypes: [RoomType.FOYER, RoomType.ENTRY, RoomType.DINING, RoomType.LIVING],
    roomEndTypes: [RoomType.FRONT_PORCH, RoomType.REAR_PORCH],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.EXT_SGL, center: true },
  },
  {
    roomStartTypes: [RoomType.MASTER_BED],
    roomEndTypes: [RoomType.PATIO],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.EXT_SLIDE },
  },

  /** Master */
  {
    roomStartTypes: [RoomType.MASTER_CLOSET],
    roomEndTypes: [RoomType.MASTER_HALL, RoomType.MASTER_BED],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.INT_26XX, center: true },
  },
  {
    roomStartTypes: [RoomType.MASTER_BATH],
    roomEndTypes: [RoomType.MASTER_HALL],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.INT_26XX, center: true },
  },
  {
    roomStartTypes: [RoomType.MASTER_BATH],
    roomEndTypes: [RoomType.MASTER_CLOSET],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.INT_26XX, center: true },
  },
  {
    roomStartTypes: [RoomType.MASTER_BATH],
    roomEndTypes: [RoomType.MASTER_BED],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.INT_26XX, center: true },
  },

  {
    roomStartTypes: [RoomType.MASTER_PASS, RoomType.MASTER_SEAT],
    roomEndTypes: [RoomType.MASTER_BED],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.OPEN_FULL },
  },
  {
    roomStartTypes: [RoomType.MASTER_PASS],
    roomEndTypes: [RoomType.MASTER_BATH],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.INT_24XX },
  },
  {
    roomStartTypes: [RoomType.MASTER_PASS],
    roomEndTypes: [RoomType.MASTER_VESTIBULE],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.INT_24XX },
  },
  {
    roomStartTypes: [RoomType.MASTER_PASS],
    roomEndTypes: [RoomType.MASTER_CLOSET],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.OPEN_30XX, center: true },
  },
  {
    roomStartTypes: [RoomType.MASTER_PASS, RoomType.BED_PASS],
    roomEndTypes: [RoomType.HALL],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.INT_24XX },
  },

  {
    roomStartTypes: [RoomType.POWDER],
    roomEndTypes: [RoomType.HALL_CASED_OPENING, RoomType.HALL_CASED_OPENING, RoomType.UTIL_HALL],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.INT_24XX },
  },

  {
    roomStartTypes: [RoomType.MASTER_VANITY],
    roomEndTypes: [RoomType.BATH_HALL],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.OPEN_FULL },
  },
  {
    roomStartTypes: [RoomType.BATH_HALL],
    roomEndTypes: [RoomType.BATH_HALL, RoomType.MASTER_VANITY],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.OPEN_FULL },
  },
  {
    roomStartTypes: [RoomType.BATH_HALL],
    roomEndTypes: [RoomType.SHOWER, RoomType.BATHTUB],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.OPEN_FULL },
  },
  {
    roomStartTypes: [RoomType.BATH_HALL],
    roomEndTypes: [RoomType.WATER_CLOSET],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.INT_20XX, center: true },
  },
  {
    roomStartTypes: [RoomType.BATH_HALL],
    roomEndTypes: [RoomType.MASTER_CLOSET],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.INT_24XX, center: true },
  },
  {
    roomStartTypes: [RoomType.MASTER_VESTIBULE],
    roomEndTypes: [RoomType.HALL],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.OPEN_30XX, center: true },
  },
  {
    roomStartTypes: [RoomType.MASTER_VESTIBULE],
    roomEndTypes: [RoomType.MASTER_BED],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.INT_26XX, center: true },
  },

  {
    roomStartTypes: [RoomType.REACH_CLOSET],
    roomEndTypes: [
      RoomType.OFFICE,
      RoomType.MASTER_BED,
      RoomType.BED_BATH,
      RoomType.HALL,
      RoomType.ENTRY,
      RoomType.GENERAL,
    ],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.CL_BYPASS, center: true },
  },

  /** Closets */
  {
    roomStartTypes: [RoomType.ENTRY],
    roomEndTypes: [RoomType.COAT_CLOSET],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.INT_20XX, center: true },
  },
  {
    roomStartTypes: [RoomType.HALL],
    roomEndTypes: [RoomType.COAT_CLOSET],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.INT_20XX, center: true },
  },
  {
    roomStartTypes: [RoomType.HALL],
    roomEndTypes: [RoomType.COAT_CLOSET],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.INT_20XX, center: true },
  },
  {
    roomStartTypes: [RoomType.BEDROOM],
    roomEndTypes: [RoomType.WALK_IN_CLOSET, RoomType.BED_CLOSET, RoomType.CLOSET],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.INT_24XX },
  },
  {
    roomStartTypes: [RoomType.BEDROOM],
    roomEndTypes: [RoomType.REACH_CLOSET],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.BYP_48XX, center: true },
  },

  {
    roomStartTypes: [RoomType.MUDROOM],
    roomEndTypes: [RoomType.FOYER],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.INT_24XX },
  },
  {
    roomStartTypes: [RoomType.REFRIGERATOR],
    roomEndTypes: [RoomType.KITCHEN],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.OPEN_FULL },
  },
  {
    roomStartTypes: [RoomType.STAIRS],
    roomEndTypes: [RoomType.HALL],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.OPEN_FULL },
  },
  {
    roomStartTypes: [RoomType.STAIRS_EDITOR],
    roomEndTypes: [RoomType.HALL],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.OPEN_FULL },
  },
  {
    roomStartTypes: [RoomType.LIVING],
    roomEndTypes: [RoomType.CABINETS],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.OPEN_FULL },
  },

  {
    roomStartTypes: [RoomType.LIVING],
    roomEndTypes: [RoomType.FIREPLACE],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.FIREPLACE, center: true },
  },

  {
    roomStartTypes: [RoomType.ENTRY],
    roomEndTypes: [RoomType.STAIRS],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.OPEN_FULL },
  },
  {
    roomStartTypes: [RoomType.ENTRY],
    roomEndTypes: [RoomType.STAIRS_EDITOR],
    options: { funcType: "DOOR", doorType: BuiltinDoorId.OPEN_FULL },
  },
];
